import { useId } from "react";
import { problemMessage } from "../../shared/api/problem";
import { useNotificationPreferences, useUpdateNotificationPreferences } from "./api";

/**
 * SA-04 §7.11: "Email me when someone mentions me", default on, shown on the Mentions page and in the account menu,
 * to partners too. `emailAvailable` false (no address, or partner mail switched off) disables it and says why; the
 * preference is still stored server-side, nothing is sent. In-app notifications are never affected by it.
 */
export function MentionEmailToggle({ enabled = true }: { enabled?: boolean }) {
  const id = useId();
  const preferences = useNotificationPreferences(enabled);
  const update = useUpdateNotificationPreferences();
  const data = preferences.data;
  const disabled = !data || data.emailAvailable === false || update.isPending;
  return (
    <div className="gf-mention-pref">
      <label className="gf-check" htmlFor={id}>
        <input id={id} type="checkbox" checked={data?.mentionEmail ?? true} disabled={disabled} aria-describedby={`${id}-why`} onChange={(event) => update.mutate(event.target.checked)} />
        Email me when someone mentions me
      </label>
      <span id={`${id}-why`} className="help">
        {preferences.isError
          ? `Email preference could not be loaded. ${problemMessage(preferences.error)}`
          : data && !data.emailAvailable
            ? "Email is not available for your account, so this cannot be turned on. You still get mentions here."
            : "You are always notified in Giraffe. This only controls the email."}
      </span>
      {update.isError && (
        <span className="msg" role="alert">
          Not saved. {problemMessage(update.error)}
        </span>
      )}
    </div>
  );
}
